/* eslint-disable quote-props */
import { Box, useMediaQuery, useTheme } from "@mui/material";
import {
  Image,
  ImageOverlay,
  layoutDrawerInnerStyle,
  layoutDrawerStyle,
} from "./LayoutDrawer.style";
import React, { FC, ReactNode, useEffect } from "react";

import { AlertCustom } from "../../styles/styledComponents";
import { AlertIcon } from "../Icons";
import { usePetStore } from "../../hooks/redux-hooks/pet-store/pet-store.service";

interface ILayoutOnboardingProps {
  children: ReactNode;
  image?: string | undefined;
  isWhite?: boolean;
  placeholder?: string;
  drawerNavbar?: ReactNode | null;
  style?: React.CSSProperties;
  socWarning?: boolean;
  socWarningClick?: () => void;
  customStyleNotification?: boolean;
}


const LayoutDrawer: FC<ILayoutOnboardingProps> = ({
  children, image, isWhite, placeholder, drawerNavbar, style, socWarning, socWarningClick, customStyleNotification,
}) => {
  const theme = useTheme();
  const mobileSize = useMediaQuery(theme.breakpoints.down("sm"));
  const { petInfo } = usePetStore();

  useEffect(() => {
    const drawerWrapperDiv = document.querySelector<HTMLElement>("#drawerRight .MuiDrawer-paper");
    const drawerNavbarDiv = document.querySelector<HTMLElement>(".drawerNavbarContainer");

    const scrollValidation = function() {
      if (
        !mobileSize &&
        drawerWrapperDiv &&
        drawerWrapperDiv.scrollTop > 30
      ) {
        drawerNavbarDiv?.classList.add("scrolled");
      } else {
        drawerNavbarDiv?.classList.remove("scrolled");
      }
    };

    drawerWrapperDiv?.addEventListener("scroll", scrollValidation);
    drawerWrapperDiv?.scrollTo({ top: 0 });

    return () => {
      drawerWrapperDiv?.removeEventListener("scroll", scrollValidation);
    };
  }, []);

  return (
    <Box sx={layoutDrawerStyle} style={{ background: isWhite ? "#ffffff" : "transparent" }}>
      {drawerNavbar}

      {socWarning && <>
        <AlertCustom
          icon={<AlertIcon fill="#ED7857" />}
          severity="error"
          sx={{
            margin: "0",
            width: "100%",
            borderRadius: "0",
          }}>
          It{"'"}s time for {petInfo?.name} to get some attention
          <b
            style={{ marginLeft: "8px", cursor: "pointer" }}
            onClick={socWarningClick}
          >
            Close
          </b>
        </AlertCustom>
      </>}

      {(image || placeholder) ? (
        <ImageOverlay>
          {
            image ? <Image src={image} alt="GoodVets" /> :
              placeholder ? <Image src={placeholder} alt="GoodVets" /> :
                null
          }
        </ImageOverlay>
      ) : null}
      <Box sx={layoutDrawerInnerStyle} style={{
        ...style,
        paddingTop: mobileSize ? "24px" :
          drawerNavbar ? "16px" : "40px",
        height: "100%",
      }}>
        {children}
      </Box>
    </Box>
  );
};

export default LayoutDrawer;
